module.exports = __webpack_public_path__ + "img/Comic05-5.b7ece297.png";